import { render, staticRenderFns } from "./MemberUnselectedItem.vue?vue&type=template&id=047f30a5&scoped=true"
import script from "./MemberUnselectedItem.vue?vue&type=script&lang=js"
export * from "./MemberUnselectedItem.vue?vue&type=script&lang=js"
import style0 from "./MemberUnselectedItem.vue?vue&type=style&index=0&id=047f30a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047f30a5",
  null
  
)

export default component.exports